// extracted by mini-css-extract-plugin
export default {"rating":"rating--9cd1e363"};